import request from './request.js';
import {requestbody} from './request.js'
// 政策知识库分页查询


export async function noticeExTemplate (params = {
}) {
return await requestbody('/noticeExTemplate/page', 'post', params)
}


export async function noticetemplate (params = {
}) {
return await requestbody('/noticeExTemplate/save', 'post', params)
}

export async function Templatedelete (params = {
}) {
return await requestbody('/noticeExTemplate/delete', 'post', params)
}

export async function noticeExTemplateupdate (params = {
}) {
return await requestbody('noticeExTemplate/update', 'post', params)
}
